import { client, useApiGet } from "./_base";

export interface Defect {
  active: 0 | 1;
  id: number;
  defect: string;
  created_at: Date;
  updated_at: Date;
  user_updated_by: number;
}

export interface DefectFull extends Defect {
  last_updated_by: string;
}

const endpoint = "defects";

export const defects = client<Defect>(endpoint, (item) => ({
  ...item,
}));

export const getAllDefects = async (): Promise<DefectFull[]> => useApiGet(`${endpoint}/ext/all`);

export const isDefectUsed = async (defect: string): Promise<{ defect: string }[]> => useApiGet(`${endpoint}/ext/is-used?defect=${defect}`);

export const getUsedDefects = async (): Promise<{ defect: string }[]> => useApiGet(`${endpoint}/ext/all-used`);
